//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationFileController_delete,
  Response$AdminObligationFileController_delete$Status$200,
  ResponseContentType$AdminObligationFileController_delete,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminObligationFileController_delete = () =>
  useApiClientMutation<
    Params$AdminObligationFileController_delete,
    Response$AdminObligationFileController_delete$Status$200[ResponseContentType$AdminObligationFileController_delete]
  >({ method: 'AdminObligationFileController_delete' });
